import React, { Component } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import ToastContainer from "sushiweb/ToastContainer";

import configureStore from "./redux/store";
import Footer from "./components/shared/footer/Footer";
import ScrollToTop from "./components/shared/scroll/ScrollToTop";
import RouteHandler from "./RouteHandler";
import "./services/datadog"
import { consumeSessionFragment } from "./services/posAuthHandoff";
import actionTypes from "./redux/actionTypes";
import DatadogOutletSync from "./services/DatadogOutletSync";

const store = configureStore();

const sessionPayload = consumeSessionFragment();
if (sessionPayload) {
  store.dispatch({
    type: actionTypes.SET_POS_AUTH_TOKEN,
    payload: sessionPayload,
  });
}

class App extends Component {
  state = {
    offline: !navigator.onLine,
  };

  setOfflineStatus = () => {
    this.setState({ offline: !navigator.onLine });
  };

  componentDidMount = () => {
    window.addEventListener("online", this.setOfflineStatus);
    window.addEventListener("offline", this.setOfflineStatus);
  };

  componentWillUnmount = () => {
    window.removeEventListener("online", this.setOfflineStatus);
    window.removeEventListener("offline", this.setOfflineStatus);
  };

  render() {
    const noInternetMessage = "No Internet Connection";
    return (
      <ToastContainer>
        <Provider store={store}>
          <BrowserRouter>
            <DatadogOutletSync />
            <ScrollToTop>
              {this.state.offline && (
                <div className="no-intenet-wrapper">
                  <span>{noInternetMessage}</span>
                </div>
              )}
              <RouteHandler />
            </ScrollToTop>
          </BrowserRouter>
        </Provider>
      </ToastContainer>
    );
  }
}

export default App;
